import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { trackEvent } from "../utils/analytics";

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    trackEvent({
      event: "page_view",
      page_location: window.location.href,
      page_path: location.pathname + location.search,
      page_title: document.title
    });
  }, [location]);

  return null;
}

export default AnalyticsTracker;
